import { render } from "./ErrorDialog.vue?vue&type=template&id=52121ca9&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"

import "./ErrorDialog.vue?vue&type=style&index=0&id=52121ca9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52121ca9"]])

export default __exports__